<template lang="pug">
pr-wrapper.background-wrapper(bg, fs, :zi="index", v-show="slides.length")
  .bar.primary-bg(v-visible="hasMultiple", ref="bar")
  pr-wrapper#background-image-container(fs, :class="active")
</template>

<script>
import { mapState } from "vuex"

export default {
  name: "background",
  data() {
    return {
      status: true,
      slides: [],
      current: 0,
      index: "2",
      timeout: null
    }
  },
  computed: {
    hasMultiple() {
      return this.slides.length > 1
    },
    active() {
      return { "background-active": this.slides.length ? true : false }
    },
    ...mapState(["background"])
  },
  watch: {
    background(nval, oval) {
      // if same background image/images do nothing.
      if (oval && oval.slides.length === nval.slides.length && oval.slides.every((item, index) => nval.slides[index] === item)) return true

      this.status = true
      this.current = 0
      this.stopSlideshow()

      if (!nval || typeof nval !== "object" || !Array.isArray(nval.slides)) {
        this.slides = []
        this.index = "2"
        this.sync()
      } else {
        this.slides = nval.slides
        this.sync().then(() => (this.index = nval.index ? "5" : "2"))
      }
    }
  },
  mounted() {
    _$.vue.$on("background", data => {
      if (data === "toggle") this.toggleSlideshow()
      else if (data === "next") this.next()
      else if (data === "prev") this.prev()
    })
  },
  methods: {
    async sync() {
      if (!this.slides.length) return this.clear()

      const uri = this.slides[this.current]
      await _$.loadImage(uri.host()).then(img => (img ? this.appendImage(img) : this.clear()))
    },
    clear() {
      document.getElementById("background-image-container").innerHTML = ""
      return true
    },

    appendImage(image, slideshow = true) {
      let duration = this.$store.state.theme.options.animate ? 500 : 0
      const container = document.getElementById("background-image-container"),
        wrapper = document.createElement("div")

      wrapper.classList.add("image-wrapper")
      $(wrapper).hide()
      wrapper.appendChild(image)

      container.appendChild(wrapper)
      $(wrapper).fadeIn(duration, () => (container.innerHTML = wrapper.outerHTML))

      if (slideshow) this.initSlideshow()
    },
    async initSlideshow() {
      if (this.timeout) clearTimeout(this.timeout)
      if (this.slides.length <= 1) return false

      this.$refs.bar.classList.add("active")
      this.timeout = setTimeout(() => {
        this.current++
        if (this.current >= this.slides.length) this.current = 0

        _$.loadImage(this.slides[this.current].host()).then(img => (img ? this.appendImage(img) : this.clear()))
        this.$refs.bar.classList.remove("active")
      }, 5000)
    },
    stopSlideshow() {
      this.$refs.bar.classList.remove("active")
      if (this.timeout) _$.removeTimeout(this.timeout)
    },
    toggleSlideshow() {
      this.status = !this.status

      if (this.status) this.initSlideshow()
      else this.stopSlideshow()

      return true
    },
    prev() {
      if (this.status) this.toggleSlideshow()

      this.current--
      if (this.current < 0) this.current = this.slides.length - 1
      _$.loadImage(this.slides[this.current].host()).then(img => (img ? this.appendImage(img, false) : this.clear()))
    },
    next() {
      if (this.status) this.toggleSlideshow()

      this.current++
      if (this.current > this.slides.length - 1) this.current = 0
      _$.loadImage(this.slides[this.current].host()).then(img => (img ? this.appendImage(img, false) : this.clear()))
    }
  }
}
</script>

<style lang="scss">
.background-wrapper {
  display: flex;
  position: relative;

  .bar {
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: 0;
    width: 0;
    height: 2px !important;
    transition: width 0s ease;
    &.active {
      width: 100%;
      transition: width 5s ease;
    }
  }

  #background-image-container {
    transition: opacity 0.2s ease-in-out;
    position: relative;
    width: 100%;
    height: 100%;

    .image-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      img {
        position: absolute;
        top: 50%;
        left: 50%;
        min-height: 100%;
        min-width: 100%;
        max-height: 100%;
        max-width: 100%;
        transform: translate(-50%, -50%);
      }
    }
  }
}
</style>
